import type { SalesSummarySettings } from './types';

export const DEFAULT_SALES_SUMMARY_SETTINGS: SalesSummarySettings = {
  period: 'month',
  referenceDate: '',
  from: '',
  to: '',
  scope: 'mine',
  branchId: null,
  managerId: null,
  compare: true,
};

// Частичная настройка дополняется общими значениями; даты проверяются расчётом на сервере.
export function decodeSalesSummarySettings(
  value: unknown,
  defaults: SalesSummarySettings = DEFAULT_SALES_SUMMARY_SETTINGS
): SalesSummarySettings {
  if (!value || typeof value !== 'object') return defaults;
  return {
    period:
      'period' in value &&
      (value.period === 'month' || value.period === 'quarter' || value.period === 'custom')
        ? value.period
        : defaults.period,
    scope:
      'scope' in value &&
      (value.scope === 'mine' || value.scope === 'branch' || value.scope === 'all')
        ? value.scope
        : defaults.scope,
    referenceDate:
      'referenceDate' in value && typeof value.referenceDate === 'string'
        ? value.referenceDate
        : defaults.referenceDate,
    from: 'from' in value && typeof value.from === 'string' ? value.from : defaults.from,
    to: 'to' in value && typeof value.to === 'string' ? value.to : defaults.to,
    branchId:
      'branchId' in value &&
      typeof value.branchId === 'number' &&
      Number.isSafeInteger(value.branchId) &&
      value.branchId > 0
        ? value.branchId
        : 'branchId' in value && value.branchId === null
          ? null
          : defaults.branchId,
    managerId:
      'managerId' in value &&
      typeof value.managerId === 'number' &&
      Number.isSafeInteger(value.managerId) &&
      value.managerId > 0
        ? value.managerId
        : 'managerId' in value && value.managerId === null
          ? null
          : defaults.managerId,
    compare:
      'compare' in value && typeof value.compare === 'boolean' ? value.compare : defaults.compare,
  };
}
